import React from 'react';
import PropTypes from 'prop-types';

class FlowGraphNodeHandle extends React.Component {
	render() {
		const { radius: r } = this.props;
		const boxSize = (r + 1) * 2;
		return (
			<svg
				className="handle"
				viewBox={`0 0 ${boxSize} ${boxSize}`}
				xmlns="http://www.w3.org/2000/svg"
				version="1.1"
			>
				<circle cx={r + 1} cy={r + 1} r={r} />
			</svg>
		);
	}
}

FlowGraphNodeHandle.propTypes = {
	radius: PropTypes.number
};

FlowGraphNodeHandle.defaultProps = {
	radius: 4
};

export default FlowGraphNodeHandle;
